import React from "react";
import Seller from "../children/Seller";
import logo from "../landingImgs/logo1.png";
import { useMediaQuery } from "react-responsive";

function BenefitsPage() {
  const isDastop = useMediaQuery({ query: "(max-width: 1600px)" });
  const isSmallLaptop = useMediaQuery({ query: "(max-width: 1200px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 900px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 650px)" });
  return (
    <div className={`${isMobile ? "flex column gap-2" : "benefit-trader"}`}>
      <Seller />

      <div
        data-aos="flip-right"
        className="flex justify-center"
        style={{ order: isMobile && 1 }}
      >
        <img
          src={logo}
          alt="logo"
          // className={`${isTablet ? "mt-1" : isLaptop ? "mt-2" : "mt-5"}`}
          style={{
            width: isMobile
              ? "80%"
              : isTablet
              ? "250px"
              : isSmallLaptop
              ? "350px"
              : isDastop
              ? "500px"
              : "547px",
          }}
        />
      </div>
    </div>
  );
}

export default BenefitsPage;
